module.exports = __webpack_public_path__ + "assets/img/star-solid.bcbe44fe.svg";